const deleteParamFromUrl = (param: string) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(param);
  window.history.replaceState(null, 'Replace url', url.href);
};

export default deleteParamFromUrl;
